
import { useState } from 'react';

export default function Portfolio() {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Projects' },
    { id: 'vehicle-wraps', name: 'Vehicle Wraps' },
    { id: 'window-tinting', name: 'Window Tinting' },
    { id: 'commercial', name: 'Commercial' },
    { id: 'signage', name: 'Signage' }
  ];

  const projects = [
    {
      id: 1,
      category: 'vehicle-wraps',
      title: 'Luxury Sports Car Wrap',
      description: 'Custom matte black wrap with carbon fiber accents',
      image: 'https://public.readdy.ai/ai/img_res/953d7d29e8d85e99ff461fbc39bf0302.jpg'
    },
    {
      id: 2,
      category: 'commercial',
      title: 'Fleet Branding Project',
      description: 'Complete fleet branding for contracting company',
      image: 'https://static.readdy.ai/image/c209f1799ad125177e0fe6e14cfcc3f4/dd95b16c8077f33bad88e824996af9a6.png'
    },
    {
      id: 3,
      category: 'window-tinting',
      title: 'Residential Window Tinting',
      description: 'Privacy and energy-efficient window films',
      image: 'https://readdy.ai/api/search-image?query=Modern%20residential%20home%20with%20professionally%20installed%20window%20tinting%2C%20elegant%20house%20exterior%20with%20tinted%20windows%20for%20privacy%20and%20energy%20efficiency%2C%20professional%20residential%20window%20film%20installation%2C%20beautiful%20home%20architecture&width=400&height=300&seq=portfolio003&orientation=landscape'
    },
    {
      id: 4,
      category: 'signage',
      title: 'Wall Murals',
      description: 'Wall murals and graphics for office or school',
      image: 'https://static.readdy.ai/image/c209f1799ad125177e0fe6e14cfcc3f4/cb14a2135f9e9e0d926c98e445ba32cf.jpeg'
    },
    {
      id: 5,
      category: 'vehicle-wraps',
      title: 'Race Car Wraps',
      description: 'Custom wraps that can handle the harsh conditions ',
      image: 'https://static.readdy.ai/image/c209f1799ad125177e0fe6e14cfcc3f4/d75f2183b8f5264d1e3ddf2d653785a6.jpeg'
    },
    {
      id: 6,
      category: 'window-tinting',
      title: 'Office Building Window films',
      description: 'Commercial building window films both energy-efficient and increased privacy ',
      image: 'https://static.readdy.ai/image/c209f1799ad125177e0fe6e14cfcc3f4/54e77a60931b265d35221a8ceae2b19d.jpeg'
    }
  ];

  const filteredProjects = activeCategory === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeCategory);

  return (
    <section id="portfolio" className="py-20 bg-gray-800">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Our Featured Work
          </h2>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Explore our portfolio of successful projects showcasing quality craftsmanship 
            and creative solutions across all our service areas.
          </p>
        </div>

        {/* Category Filter */}
        <div className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) => (
            <button
              key={category.id}
              onClick={() => setActiveCategory(category.id)}
              className={`px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                activeCategory === category.id
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-gray-700 text-gray-300 hover:bg-gray-600 hover:text-white'
              }`}
            >
              {category.name}
            </button>
          ))}
        </div>

        {/* Portfolio Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project) => (
            <div key={project.id} className="group relative overflow-hidden rounded-xl bg-gray-900 shadow-xl hover:shadow-2xl transition-all duration-300 border border-gray-700 hover:border-blue-500/50">
              <div className="relative h-64 overflow-hidden">
                <img 
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                
                {/* Overlay Content */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <button className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-7
                    transition-colors cursor-pointer whitespace-nowrap font-medium">
                    View Details
                  </button>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-semibold text-white mb-2">{project.title}</h3>
                <p className="text-gray-300 text-sm leading-relaxed">{project.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button className="bg-blue-600 text-white px-8 py-4 text-lg font-semibold rounded-lg hover:bg-blue-700 transition-colors cursor-pointer whitespace-nowrap shadow-lg">
            View Complete Portfolio
          </button>
        </div>
      </div>
    </section>
  );
}
